import React, { useEffect, useState, useMemo } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useActiveUserBarCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useActiveUserBarCharts';
import useActiveUserLineCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useActiveUserLineCharts';
import useActiveUserPieCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useActiveUserPieCharts';
import { sortBySourceMetricList } from '@/pages/intelligence/utils/topchartsUtils';
import { createDataSourceMetricForValue } from '@/pages/intelligence/pages/Following/_config/util';

export default function VisualisAnnieSensortower(props: any) {
  const {
    APPID,
    dataSources = ['appannie', 'sensortower'],
    fetchParams,
    barOrPieData,
    lineData,
    sourceOrders = ['appannie', 'sensortower'],
    echartsData,
    dateType,
    isVisualisLoading,
    chartType = 'bar',
    orderTypeInfo,
    isDataBrain,
    titleNow = '',
    topChartsType = '',
    isNodata,
    metric,
    entityType,
    chartsInstance,
  } = props;

  const DATA_SOURCE_NAME_MAP = {
    ogdb: 'DataBrain',
    appannie: 'data.ai',
    sensortower: 'Sensor Tower',
  } as any;

  const [chartsData, setChartsData] = useState<any>({
    metricChartlist: [],
    timelineOfMetricChartlist: [],
  });

  const dataSourceNames = useMemo(() => {
    if (!Array.isArray(dataSources)) return [];
    return dataSources.map((item) => DATA_SOURCE_NAME_MAP[item]).filter((item) => item);
  }, [dataSources]);

  const isDualSourceMetricName = (metricName: string) =>
    metricName === `appannie_${metric}` || metricName === `sensortower_${metric}`;

  // 该函数的目的是补全缺失的dau指标对象
  const getFullDauMetrics = (metrics: any[]): any[] => {
    // 检查传入的metrics是否为数组，如果不是则返回空数组
    if (!Array.isArray(metrics)) return [];

    // 获取已有指标对象中的dauMetricsSources，即数据源
    const dauMetricsSources = metrics.map((item) => item.data_source);

    // 获取丢失的dau指标数据源，以进行补全
    const lostDauMetricsSources = (dataSources || []).filter(
      (item: string) => !dauMetricsSources.includes(item),
    );

    // 如果没有丢失的dau数据源，直接返回原始metrics数据
    if (!lostDauMetricsSources.length) return metrics;

    // 构建一个新数组，将原始metrics数据存入新数组中
    const fullDauMetrics = [...metrics];

    // 遍历丢失的dau指标数据源
    for (let i = 0; i < lostDauMetricsSources.length; i++) {
      // 获取当前遍历的失去的dau数据源
      const lostDauMetricSource = lostDauMetricsSources[i];

      // 构建一个新的dau指标对象
      const lostDauMetric = {
        source: lostDauMetricSource, // 数据源
        data_source: lostDauMetricSource, // 数据源
        value: '', // 值
        growth_ratio: '', // 增长率
        b_predict: false, // 是否预测
        metric, // 指标类型
        order_metric: `${lostDauMetricSource}_${metric}`, // 排序指标
        order_source: lostDauMetricSource, // 排序数据源
        titleNow, // 标题
      };

      // 将新构建的dau指标对象添加到完整的dau指标数组中
      fullDauMetrics.push(lostDauMetric);
    }

    // 返回完整的dau指标数组
    return fullDauMetrics;
  };
  const getSortedMetrics = (metrics: any[]): any[] => {
    if (!Array.isArray(metrics)) return [];
    return metrics.sort((a: any, b: any): number => {
      const aIndex = sourceOrders.indexOf(a.source);
      const bIndex = sourceOrders.indexOf(b.source);
      return aIndex - bIndex;
    });
  };

  const getBarOrPieDataOfComponent = (games: any[]) => {
    const result: any[] = [];
    if (!Array.isArray(games)) return [];

    for (let i = 0; i < games.length; i++) {
      const game = games[i];
      let newGame = null;
      let metricValueList = [];
      const newMetricValueList = [];
      const metricsTmp: string[] = [];
      if (!game || !game[APPID]) continue;

      metricValueList = Array.isArray(game.metric_list) ? game.metric_list : [];
      // 按数据源与指标名称重新排序，再下传
      const metricValueListTemp = sortBySourceMetricList(
        dataSourceNames || [],
        metricValueList,
        DATA_SOURCE_NAME_MAP,
      );
      for (let j = 0; j < metricValueListTemp.length; j++) {
        const metricValue = metricValueListTemp[j];
        const metricName = createDataSourceMetricForValue(
          metricValue?.metric,
          metricValue?.data_source,
        );
        if (!metricsTmp.includes(metricName) && isDualSourceMetricName(metricName)) {
          metricsTmp.push(metricName);
          const newMetricValue = {
            ...metricValue,
            b_predict: false,
            metric: metricValue.data_source,
            order_metric: metricValue.metric,
            order_source: metricValue.data_source,
            titleNow,
          };
          newMetricValueList.push(newMetricValue);
        }
      }
      newGame = {
        ...game,
        id: game[APPID],
        imageUrl: game.cover,
        name: game.name,
        rank_metric: game.name,
        metric_list: newMetricValueList,
        // metric_value_list: getSortedMetrics(
        //   getFullDauMetrics(newMetricValueList),
        // ),
        // metric_list: metricValueList,
      };
      result.push(newGame);
    }

    return result;
  };
  // 该函数的目的是从游戏数组中提取所需的数据以绘制折线图
  const getLineDataOfComponent = (games: any): any[] => {
    // 初始化结果数组
    const result: any[] = [];

    // 检查传入的games是否为数组
    if (Array.isArray(games)) {
      // 遍历游戏数组
      for (let i = 0; i < games?.length; i++) {
        const game = games[i];

        if (!game) continue;

        const timeLines = game.times;

        // 检查timeLines是否为数组
        if (!Array.isArray(timeLines)) continue;

        // 遍历timeLines数组
        for (let j = 0; j < timeLines.length; j++) {
          const timeLine = timeLines[j];

          if (!timeLine) continue;

          const time = timeLine.date;
          let metricValueList = timeLine.metric_list;

          // 检查metricValueList是否为数组，若不是则将其设置为空数组
          metricValueList = Array.isArray(metricValueList) ? metricValueList : [];
          // 折线数据做数据源排序处理；避免出现数据乱套
          const metricValueListTemp = sortBySourceMetricList(
            dataSourceNames || [],
            getFullDauMetrics(metricValueList),
            DATA_SOURCE_NAME_MAP,
          );

          // 使用getSortedMetrics() 和 getFullDauMetrics()函数处理metricValueList数组
          // metricValueList = getSortedMetrics(
          //   getFullDauMetrics(metricValueList),
          // );

          if (!time || !Array.isArray(metricValueListTemp)) continue;

          const newMetricValueList: any = [];

          // 遍历metricValueList数组生成新的newMetricValueList数组
          for (let k = 0; k < metricValueListTemp.length; k++) {
            const metricItem = metricValueListTemp[k];

            if (!metricItem) continue;

            const metricName = createDataSourceMetricForValue(
              metricItem?.metric,
              metricItem?.data_source,
            );
            if (!isDualSourceMetricName(metricName)) {
              continue;
            }

            // 将相关属性添加到newMetricValueList数组中的每一个对象
            newMetricValueList.push({
              ...metricItem,
              b_predict: metricItem.predict,
              metric: metricItem.metric,
              order_source: metricItem.data_source,
              order_metric: `${metricItem.metric}`,
              titleNow,
            });
          }

          // 为结果数组添加新对象
          result.push({
            ...game,
            time,
            rank_name: game.name,
            metric_value_list: newMetricValueList,
          });
        }
      }
    }

    // 返回结果数组
    return result;
  };

  useEffect(() => {
    const barOrPieDataOfComponent = getBarOrPieDataOfComponent(barOrPieData);
    const lineDataOfComponent = getLineDataOfComponent(lineData);

    setChartsData({
      ...chartsData,
      metricChartlist: barOrPieDataOfComponent,
      timelineOfMetricChartlist: lineDataOfComponent,
    });
  }, [barOrPieData, lineData, metric]);

  const lenten = useMemo(() => {
    return chartsData.metricChartlist
      ? chartsData.metricChartlist.filter((item: any, index: any) => index < 10)
      : chartsData.metric_chart_list.filter((item: any, index: any) => index < 10);
  }, [chartsData]);
  // 获取柱状图hooks
  const { barOption, showBarPeiName } = useActiveUserBarCharts({
    sendEchartsData: chartsData,
    loading: isVisualisLoading,
    dataSourceEachers: dataSourceNames,
    isDataBrain,
    lenten,
    titleNow,
    topChartsType: topChartsType || 'activeuser',
    startDate: fetchParams?.start_date,
    endDate: fetchParams?.end_date,
  });

  // 获取折线图hooks
  const { lineOption } = useActiveUserLineCharts({
    sendEchartsData: chartsData,
    loading: isVisualisLoading,
    dataSourceEachers: dataSourceNames,
    titleNow,
    topChartsType: ['D2', 'D3', 'D7', 'D15', 'D31'].includes(metric) ? 'retention' : topChartsType || 'activeuser',
    imageType: entityType,
    chartType,
    dateType,
    chartsInstance,
    followingRetentionLegend: ['D2', 'D3', 'D7', 'D15', 'D31'].includes(metric),
  });
  // 获取饼图hooks
  const { pieOption } = useActiveUserPieCharts({
    chartType,
    chartsInstance,
    sendEchartsData: chartsData,
    loading: isVisualisLoading,
    dataSourceEachers: dataSourceNames,
    lenten,
    titleNow,
    startDate: fetchParams?.start_date,
    endDate: fetchParams?.end_date,
  });

  return (
    <ChartsIndex
      ref={chartsInstance}
      echartsData={{}}
      dataSourceEachers={dataSourceNames}
      chartLoading={isVisualisLoading}
      barOption={barOption}
      lineOption={lineOption}
      pieOption={pieOption}
      chartType={chartType}
      showBarPeiName={showBarPeiName}
      isNodata={!barOrPieData?.length}
    />
  );
}
